import { FC, lazy } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import { Successful } from 'src/hooks/use-axios';
import { useTitle } from 'src/hooks/use-title';
import { OrganisationServiceRequest } from 'src/pages/settings/organisation/use-organisation-service';
import { usePageParams } from 'src/pages/settings/organisation/users/use-page-params';
import { useUsers } from 'src/pages/settings/organisation/users/use-users';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('src/pages/settings/organisation/users/page'));

type Props = {
  organisationService: Successful<OrganisationServiceRequest>;
};

export const UsersOverview: FC<Props> = ({ organisationService }) => {
  useTitle('User Management');
  if (!organisationService.response.data._links.getAllOrganisationUsers)
    throw new Forbidden();

  const pageParams = usePageParams();
  const users = useUsers({
    url: organisationService.response.data._links.getAllOrganisationUsers.href,
  });

  if (!users.response) return <PageSpinner />;

  return <Page users={users} pageParams={pageParams} />;
};
